import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { formatNumber, formatScientificNumber, isScientificNotation } from "../../utils/helper";
import ClipLoaderComponent from "../loader/ClipLoaderComponent";

function Confirmation({
  setIsClaimModalOpen,
  rewards,
  ClaimReward,
  btnloading,
  key,
  isDelegator,
  message
}) {

  const [isTotalRewardsToolTipOpen, setIsTotalRewardsToolTipOpen] =
    useState(false);
  const [isTotalCommissionToolTipOpen, setIsTotalCommissionToolTipOpen] =
    useState(false);
  const [isTotalDelegatorRewardToolTipOpen, setIsTotalDelegatorRewardToolTipOpen] =
    useState(false);
  const total_unclaimed_comission = rewards?.total_unclaimed_comission ?? 0;
  const total_unclaimed_rewards = rewards?.total_unclaimed_rewards ?? 0;
  const totalRewards = total_unclaimed_rewards + total_unclaimed_comission;
  const validatorCommission = rewards?.total_unclaimed_comission;
  const delegatorReward = rewards?.total_unclaimed_rewards;

  const [integerPart, decimalPart] = rewards.toString().split('.');
  const formattedNumber = integerPart + '.' + (decimalPart ? decimalPart.slice(0, 12) : '0'.repeat(12));

  const formattedRewards =
    rewards > 1
      ? rewards.toLocaleString("en-US")
      : isScientificNotation(rewards)
        ? formatScientificNumber(rewards, 18)
        : formattedNumber;


  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed top-0 left-0 w-screen h-screen bg-vampireBlack/90 z-50 overflow-y-auto overflow-x-hidden flex"
      >
        <div className="flex items-center justify-center w-full h-auto xsm:h-full px-4 forMobile">
          <motion.div
            initial={{
              opacity: 0,
              scale: 0,
              transition: {
                duration: 0.3,
              },
            }}
            animate={{
              opacity: 1,
              scale: 1,
              transition: {
                duration: 0.3,
                mass: 0.8,
                type: "spring",
              },
            }}
            exit={{
              opacity: 0,
              scale: 0,
              transition: {
                duration: 0.3,
              },
            }}
            className="max-w-[633px] w-full bg-[#010101] border-2 border-primaryWhite/[0.06] rounded-[32px] px-4 py-7 md:px-[103px] md:py-[38px] mx-auto my-5"
          >
            <div className="flex items-center justify-between flex-col gap-3 md:gap-[22px]">
              <span className="w-[50px] h-[50px] md:w-[70px] md:h-[70px] *:w-full *:h-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="71"
                  height="70"
                  viewBox="0 0 71 70"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    width="70"
                    height="70"
                    rx="16"
                    fill="#4CD4FF"
                    fillOpacity="0.1"
                  />
                  <path
                    d="M35.5019 23.6539C29.2438 23.6539 24.154 28.745 24.154 35.0018C24.154 41.2581 29.2452 46.3497 35.5019 46.3497C41.7586 46.3497 46.8498 41.2585 46.8498 35.0018C46.8498 28.7437 41.7586 23.6539 35.5019 23.6539ZM33.9952 33.9228H37.0069C38.0994 33.9228 39.1263 34.3474 39.8995 35.1206C40.6727 35.892 41.0972 36.9207 41.0972 38.0132C41.0972 40.2689 39.2609 42.1035 37.0069 42.1035H36.5788V43.9744H34.4215V42.1035H33.9935C31.7377 42.1035 29.9031 40.2672 29.9031 38.0132H32.0605C32.0605 39.0798 32.9286 39.9462 33.9935 39.9462H37.0051C38.0717 39.9462 38.9381 39.0781 38.9381 38.0132C38.9381 37.4954 38.7379 37.0104 38.3721 36.6462C38.0062 36.2804 37.5212 36.0802 37.0051 36.0802H33.9952C31.7394 36.0802 29.9048 34.2439 29.9048 31.9898C29.9048 30.8956 30.3311 29.8687 31.1026 29.0972C31.8758 28.3257 32.9027 27.8995 33.9952 27.8995H34.4232V26.0286H36.5806V27.8995H37.0086C39.2643 27.8995 41.0989 29.7358 41.0989 31.9898H38.9416C38.9416 30.9232 38.0735 30.0568 37.0086 30.0568L33.9952 30.0534C33.4791 30.0534 32.9942 30.2536 32.6282 30.6194C32.2624 30.9836 32.0622 31.4703 32.0622 31.9864C32.0622 33.0547 32.9286 33.9228 33.9952 33.9228ZM51.1642 28.3827C50.3081 26.3583 49.0828 24.5409 47.5208 22.9792C45.9589 21.4172 44.1415 20.1919 42.1173 19.3358C40.022 18.4487 37.7956 18 35.5 18C33.2046 18 30.9783 18.4487 28.8827 19.3358C26.8583 20.1919 25.0409 21.4172 23.4792 22.9792C21.9175 24.5411 20.6919 26.3585 19.8358 28.3827C18.9487 30.478 18.5 32.7043 18.5 35C18.5 37.2956 18.9487 39.5217 19.8358 41.6173C20.6919 43.6417 21.9172 45.4591 23.4792 47.0208C25.0411 48.5825 26.8585 49.8081 28.8827 50.6642C30.978 51.5513 33.2043 52 35.5 52C37.7954 52 40.0217 51.5513 42.1173 50.6642C44.1417 49.8081 45.9591 48.5828 47.5208 47.0208C49.0828 45.4589 50.3081 43.6415 51.1642 41.6173C52.0513 39.522 52.5 37.2956 52.5 35C52.5017 32.7063 52.0513 30.4801 51.1642 28.3827ZM45.051 44.551C42.5002 47.1018 39.1089 48.5067 35.5018 48.5067C31.8947 48.5067 28.5033 47.1018 25.9526 44.551C23.4017 42.0001 21.9968 38.6088 21.9968 35.0018C21.9968 31.3946 23.4017 28.0032 25.9526 25.4525C28.5034 22.9017 31.8947 21.4968 35.5018 21.4968C39.1089 21.4968 42.5004 22.9017 45.051 25.4525C47.6017 28.0034 49.0068 31.3947 49.0068 35.0018C49.0068 38.6089 47.6019 42.0003 45.051 44.551Z"
                    fill="#4CD4FF"
                  />
                </svg>
              </span>
              <h4 className="text-primaryWhite text-xxl md:text-1xl font-semibold -tracking-[1.8px]">
                Claim Your Reward!
              </h4>
            </div>
            <div className="bg-[#121212] rounded-2xl px-5 py-[27px] text-center mt-5 md:mt-[25px] mb-5">
              <p className="text-primaryWhite/[0.74] text-xsm/[21px] font-medium -tracking-[0.42px] mb-[9px]">
                Your Reward
              </p>
              <div className="flex items-center justify-center">
                <h4 className="pr-1 text-primaryWhite text-xl md:text-[28px]/[42px] font-semibold -tracking-[1.4px]">
                  {formatNumber(rewards)}{" "}
                  $VANRY
                </h4>
                <div
                  className="relative md:w-[18px] md:h-[18px] text-[#FFF5F566]/35 hover:text-white/80"
                  onMouseEnter={() =>
                    setIsTotalRewardsToolTipOpen(true)
                  }
                  onMouseLeave={() =>
                    setIsTotalRewardsToolTipOpen(false)
                  }
                >
                  {isTotalRewardsToolTipOpen && (
                    <div className="absolute right-[-6px] tooltip_custom bg-white text-[#06080C] rounded-[8px] py-[6px] px-4 w-max">
                      <p className="text-[10px] lg:text-[14px] font-medium break-words">
                        {formattedRewards}
                      </p>
                    </div>
                  )}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    style={{ width: "100%", height: "100%" }}
                  >
                    <path
                      d="M10.9997 20.1667C16.0413 20.1667 20.1663 16.0417 20.1663 11C20.1663 5.95837 16.0413 1.83337 10.9997 1.83337C5.95801 1.83337 1.83301 5.95837 1.83301 11C1.83301 16.0417 5.95801 20.1667 10.9997 20.1667Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11 7.33337V11.9167"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10.9951 14.6666H11.0034"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            {/* {validatorCommission > 0 && */}
            {message && <div className="bg-[#121212] rounded-2xl px-[18px] py-4 mb-5 space-y-5">

              <div className="flex items-center justify-between text-primaryWhite text-xs md:text-xsm/5 font-medium -tracking-[0.7px]">

                {message}
              </div>
            </div>}
            <div className="flex items-center justify-between gap-[14px] *:w-full">
              <button
                onClick={() => setIsClaimModalOpen(false)}
                type="button"
                disabled={btnloading}
                className={`inline-flex justify-center items-center bg-white text-[#06080C] rounded-full px-7 h-10 md:h-[52px] text-xsm lg:text-sm/6 font-medium  outline-0 -tracking-[0.48] duration-300 ${btnloading
                  ? "opacity-50 cursor-not-allowed"
                  : ""
                  }`}
              >
                Cancel
              </button>
              <button
                onClick={ClaimReward}
                type="button"
                disabled={btnloading}
                className={`inline-flex justify-center items-center bg-green text-[#06080C] rounded-full px-7 h-10 md:h-[52px] text-xsm lg:text-sm/6 font-medium  outline-0 -tracking-[0.48] duration-300 ${btnloading
                  ? "opacity-50 cursor-not-allowed"
                  : ""
                  }`}
              >
                {btnloading ? (
                  <ClipLoaderComponent
                    border="black"
                    size={30}
                  />
                ) : (
                  "Confirm"
                )}
              </button>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

export default Confirmation;
